/**
 * safeArea — iOS WKWebView 의 env(safe-area-inset-*) desync 보정 트리거.
 *
 * iOS 네이티브(MainViewController)는 콜드런치/리로드 시 safe-area 를 강제로 flush 하지만,
 * SPA 라우트 전환(React Router navigate)은 리로드가 아니라 네이티브가 감지하지 못한다.
 * Apple 로그인 시트/인앱 브라우저 복귀 직후 "홈으로 navigate" 같은 전환에서 AppBar 가
 * 노치에 붙는 증상이 재발하므로, 라우트가 바뀔 때마다 네이티브에 flush 를 요청한다.
 *
 * 네이티브는 WKScriptMessageHandler("templateSafeAreaFlush") 로 수신한다(전용 플러그인 불필요).
 * 안드로이드/웹에서는 no-op.
 */
import { isNative, getPlatform, nativeWarn } from "./index";

interface WebkitMessageBridge {
  webkit?: {
    messageHandlers?: Record<string, { postMessage: (body: unknown) => void } | undefined>;
  };
}

/** iOS 네이티브에서 safe-area flush 를 요청한다. 그 외 환경은 no-op. */
export function flushNativeSafeArea(): void {
  if (!isNative() || getPlatform() !== "ios") return;
  try {
    const bridge = window as unknown as WebkitMessageBridge;
    bridge.webkit?.messageHandlers?.templateSafeAreaFlush?.postMessage(null);
  } catch (err) {
    nativeWarn("safeArea", err);
  }
}
